import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'
import './style/index.scss';
import App from './App';
import HttpsRedirect from 'react-https-redirect';

createRoot(document.getElementById('root')).render(
    <BrowserRouter>
        <React.StrictMode>
            <HttpsRedirect>
                <App/>
            </HttpsRedirect>
        </React.StrictMode>
    </BrowserRouter>
);
